module.exports = __webpack_public_path__ + "5ab39a3ac940b35021c6315305da4a63.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/tryggvi-gylfason.jpg
 ** module id = 429
 ** module chunks = 0
 **/